import { useEffect, useState } from "react";
import apiFetch from "@wordpress/api-fetch";
import he from "he";

const formatProductForSelect = (item, type) => {
  let label = he.decode(item.title.rendered);
  let value = "";
  let variantAdditionalFields = {};

  switch (type) {
    case "product":
      value = item.id;
      break;
    case "variant":
      label += ` ${item.meta_input.size}`;
      value = `${item.ID}-${item.meta_input.code_ean}`;
      variantAdditionalFields = {
        size: item.meta_input.size,
        ean: item.meta_input.code_ean,
        description: item.meta_input.description || "",
        image: item.meta_input.image || "",
        productID: item.ID,
      };
      break;
    case "brand":
      value = item.acf.brand_tax_id;
      break;
    default:
      break;
  }

  return {
    value: value,
    label: label,
    ...variantAdditionalFields,
  };
};

export const getAllSelectItems = (path, callback, defaultItem) => {
  apiFetch({ path }).then((res) => {
    let data = [];
    if (defaultItem) {
      data.push(defaultItem);
    }
    if (res) {
      if (Array.isArray(res)) {
        data = res;
      } else {
        data.push(res);
      }
    }
    callback(data);
  });
};

export const useProductSelectItems = (
  selectedBrandId,
  searchKeyword = "",
  currentProduct = null
) => {
  const [brands, setBrands] = useState([{ value: "0", label: "All" }]);
  const [products, setProducts] = useState([]);
  const [variants, setVariants] = useState([]);

  /**
   * Get all brands
   */
  useEffect(() => {
    const params = new URLSearchParams({
      per_page: -1,
      orderby: "title",
      order: "asc",
      _embed: true,
      acf_format: "standard",
      suppress_filter: false,
      _fields: "title, acf.brand_tax_id",
    }).toString();

    getAllSelectItems(
      `/wp/v2/brand?${params}`,
      (data) =>
        setBrands(
          data
            .filter((item) => item?.acf?.brand_tax_id)
            .map((item) => formatProductForSelect(item, "brand"))
        ),
      { value: "0", label: "All" }
    );
  }, []);

  /**
   * Get all products
   */
  useEffect(() => {
    const params = new URLSearchParams({
      per_page: -1,
      orderby: "title",
      order: "asc",
      ...(selectedBrandId > 0 && { product_brand: selectedBrandId }),
    }).toString();

    getAllSelectItems(`/wp/v2/product?${params}`, (data) =>
      setProducts(data.map((item) => formatProductForSelect(item, "product")))
    );
  }, [selectedBrandId]);

  /**
   * Get all variants
   */
  useEffect(() => {
    getAllSelectItems("/sbm/v1/variants", (data) =>
      setVariants(data.map((item) => formatProductForSelect(item, "variant")))
    );
  }, [selectedBrandId]);

  /**
   * Suggested products filtered by keyword
   */
  const filteredProducts = products.filter((p) =>
    p.label.toLowerCase().includes(searchKeyword.toLowerCase())
  );

  /**
   * Suggested variants filtered by keyword and parent product
   */
  const filteredVariants = variants.filter(
    (p) =>
      p.label.toLowerCase().includes(searchKeyword.toLowerCase()) &&
      currentProduct?.value === p.productID
  );

  return {
    brands,
    products,
    variants,
    filteredProducts,
    filteredVariants,
  };
};

export default useProductSelectItems;
